import lodashOrderBy from "lodash/orderBy";
import {
  GET_ASSETS_REFRESH_MAP,
  GET_ASSETS,
  SAVE_ASSET,
  DELETE_ASSET,
  GET_ASSET_TYPES,
  GET_ASSET_CUSTOM_FIELDS,
  SAVE_ASSET_TYPES,
  SAVE_ASSET_CUSTOM_FIELDS,
  GET_ASSETS_SELECTED,
  GET_ASSETS_TABLE_OPTIONS,
} from "./actions.type";
import {
  SET_ASSETS_REFRESH_MAP,
  SET_ASSETS,
  SET_ASSET_TYPES,
  SET_ASSET_CUSTOM_FIELDS,
  SET_ASSETS_SELECTED,
  SET_ASSETS_TABLE_OPTIONS,
} from "./mutations.type";
import {
  addAsset,
  addAssetType,
  addCustomField,
  deleteAsset,
  editAsset,
  editAssetType,
  editCustomField,
  getAssets,
  getAssetTypes,
  getCustomFields,
} from "@/services/assetManagement/assets.service";

const STATE = {
  refreshMap: false,
  assets: [],
  assetTypes: [],
  assetCustomFields: [],
  assetsSelected: [],
  options: {},
};

const GETTERS = {
  refreshMap: (state) => state.refreshMap,
  assets: (state) => state.assets,
  assetTypes: (state) => state.assetTypes,
  assetCustomFields: (state) => state.assetCustomFields,
  assetsSelected: (state) => state.assetsSelected,
  options: (state) => state.options,
};

const ACTIONS = {
  [GET_ASSETS_REFRESH_MAP](context, params) {
    context.commit(SET_ASSETS_REFRESH_MAP, params);
  },
  async [GET_ASSETS](context, params) {
    try {
      const results = await getAssets(params);
      context.commit(SET_ASSETS, results);
    } catch (error) {
      console.error("Error in GET_ASSETS action: " + error);
    }
  },
  async [GET_ASSET_TYPES](context, params) {
    try {
      const results = lodashOrderBy(await getAssetTypes(), ["title"], ["asc"]);
      context.commit(SET_ASSET_TYPES, results);
    } catch (error) {
      console.error("Error in GET_ASSET_TYPES action: " + error);
    }
  },
  async [GET_ASSET_CUSTOM_FIELDS](context, params) {
    try {
      const results = lodashOrderBy(
        await getCustomFields(),
        ["title"],
        ["asc"]
      );
      context.commit(SET_ASSET_CUSTOM_FIELDS, results);
    } catch (error) {
      console.error("Error in GET_ASSET_CUSTOM_FIELDS action: " + error);
    }
  },
  async [SAVE_ASSET](context, params) {
    try {
      params.hasOwnProperty("id")
        ? await editAsset(params)
        : await addAsset(params);
      const _options = JSON.parse(JSON.stringify(STATE.options));
      await context.dispatch(GET_ASSETS, {
        options: !_options ? {} : _options,
      });
    } catch (error) {
      console.error("Error in SAVE_ASSET actions: " + error);
    }
  },
  async [DELETE_ASSET](context, params) {
    try {
      await deleteAsset(params);
    } catch (error) {
      console.error("Error in DELETE_ASSET actions: " + error);
    }
  },
  async [SAVE_ASSET_TYPES](context, params) {
    try {
      if (params.isDraft) {
        delete params.id;
        delete params.isDraft;
        delete params.orderBy;
        await addAssetType(params);
      } else {
        await editAssetType(params);
      }
      await context.dispatch(GET_ASSET_TYPES);
      const _options = JSON.parse(JSON.stringify(STATE.options));
      await context.dispatch(GET_ASSETS, {
        options: !_options ? {} : _options,
      });
    } catch (error) {
      console.error("Error in SAVE_ASSET_TYPES actions: " + error);
    }
  },
  async [SAVE_ASSET_CUSTOM_FIELDS](context, params) {
    try {
      if (params.isDraft) {
        delete params.id;
        delete params.isDraft;
        await addCustomField(params);
      } else {
        await editCustomField(params);
      }
      await context.dispatch(GET_ASSET_CUSTOM_FIELDS);
      const _options = JSON.parse(JSON.stringify(STATE.options));
      await context.dispatch(GET_ASSETS, {
        options: !_options ? {} : _options,
      });
    } catch (error) {
      console.error("Error in SAVE_ASSET_CUSTOM_FIELDS actions: " + error);
    }
  },
  async [GET_ASSETS_SELECTED](context, params) {
    try {
      context.commit(SET_ASSETS_SELECTED, params);
    } catch (error) {
      console.error("Error in GET_ASSETS_SELECTED action: " + error);
    }
  },
  [GET_ASSETS_TABLE_OPTIONS](context, params) {
    context.commit(SET_ASSETS_TABLE_OPTIONS, params);
  },
};

const MUTATIONS = {
  [SET_ASSETS_REFRESH_MAP](state, data) {
    state.refreshMap = data;
  },
  [SET_ASSETS](state, data) {
    state.assets = data;
  },
  [SET_ASSET_TYPES](state, data) {
    state.assetTypes = data;
  },
  [SET_ASSET_CUSTOM_FIELDS](state, data) {
    state.assetCustomFields = data;
  },
  [SET_ASSETS_SELECTED](state, data) {
    state.assetsSelected = data;
  },
  [SET_ASSETS_TABLE_OPTIONS](state, data) {
    state.options = data;
  },
};

export default {
  namespaced: true,
  state: STATE,
  getters: GETTERS,
  mutations: MUTATIONS,
  actions: ACTIONS,
};
